import React from 'react';
import { Typography, Box, Paper, Chip } from '@mui/material';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import NewReleasesRoundedIcon from '@mui/icons-material/NewReleasesRounded';
import ReleaseCard from './ReleaseCard';

const ReleaseTimeline = ({ filteredUpdates, sortedUpdatesLength, latestUpdate, hasLoadError, isLoading, accentColors, getReleaseArtwork, getReleaseStatus, getReleaseEnhancement }) => (
    <>
        <Box id="release-highlights" className="whats-new-section-head">
            <NewReleasesRoundedIcon />
            <Typography className="whats-new-section-title">Release Highlights</Typography>
            <Chip label={`${filteredUpdates.length} ${filteredUpdates.length === 1 ? 'story' : 'stories'}`} size="small" className="whats-new-section-count" />
        </Box>
        {filteredUpdates.length > 0 ? (
            <Box className="whats-new-timeline">
                {filteredUpdates.map((item, index) => (
                    <ReleaseCard
                        key={item?.slug || item?.id || index}
                        item={item}
                        accent={accentColors[index % accentColors.length]}
                        artwork={getReleaseArtwork(item)}
                        isLatestRelease={item === latestUpdate}
                        releaseEnhancement={getReleaseEnhancement(item)}
                        releaseStatus={getReleaseStatus(item)}
                    />
                ))}
            </Box>
        ) : !isLoading ? (
            <Paper elevation={0} className="whats-new-empty-state">
                <SearchOffRoundedIcon />
                <Typography className="whats-new-empty-title">
                    {hasLoadError ? 'Updates are temporarily unavailable' : sortedUpdatesLength === 0 ? 'No releases have been published yet' : 'No release updates match your selection'}
                </Typography>
                <Typography className="whats-new-empty-subtitle">
                    {hasLoadError ? 'Please refresh the page or try again shortly.' : sortedUpdatesLength === 0 ? 'New product announcements will appear here when they are ready.' : 'Adjust your search terms or choose a different SPARTA product to view available updates.'}
                </Typography>
            </Paper>
        ) : null}
    </>
);

export default ReleaseTimeline;
